<ion-segment
  style="width: 100%"
  mode="md"
  (ionChange)="segmentChanged($event)"
  [value]="selectedTab"
>
  <ion-segment-button [value]="0">
    <ion-label>Maschinen</ion-label>
  </ion-segment-button>
  <ion-segment-button [value]="1">
    <ion-label>DGUV-Prüfungen</ion-label>
  </ion-segment-button>
</ion-segment>
@if(selectedTab == 0){
<lib-machine-overview></lib-machine-overview>
} @if(selectedTab == 1){
<lib-inspection-overview></lib-inspection-overview>
}
